<template>
  <v-card :elevation="$root.ele" class="mt-5">
    <v-data-table
      :search="search"
      :headers="headers"
      :footer-props="{
        'items-per-page-options': [10, 20, 50, -1],
      }"
      :items-per-page="50"
      class="templates-table"
      :items="list"
    >
      <template v-slot:top>
        <div class="pa-4">
          <v-text-field
            hide-details=""
            label="Search"
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            outlined
            dense
          >
          </v-text-field>
        </div>
      </template>
      <template v-slot:item.action="{ item }">
        <div class="d-flex">
          <v-btn icon @click="$router.push(`/technicians/${item.id}`)">
            <v-icon> mdi-pencil </v-icon>
          </v-btn>
          <v-btn icon @click="openChat(item)">
            <v-icon> mdi-chat-processing-outline </v-icon>
          </v-btn>
        </div>
      </template>
      <template v-slot:item.updated_by="{ item }">
        {{ updated(item) }}
      </template>
      <template v-slot:item.zones="{ value }">
        {{
          value && value.length == 10 ? "All" : value ? value.toString() : ""
        }}
      </template>
      <template v-slot:item.type="{ item }">
        {{ getTechnicianType(item) }}
      </template>
      <template v-slot:item.phone="{ item }">
        <a :href="`tel:${item.phone}`">
          {{ formatPhone(item.phone) }}
        </a>
      </template>
      <template v-slot:item.name="{ item }">
        <div class="text-capitalize">
          {{ item.name }}
        </div>
      </template>
    </v-data-table>
    <v-divider></v-divider>
  </v-card>
</template>

<script>
import { formatPhone } from "../../assets/js/common";
import types from "../../assets/js/types";
export default {
  data() {
    return {
      lastDoc: null,
      types: types,
      search: "",
      id: "",
    };
  },
  computed: {
    headers() {
      let headers = [
        { text: "NAME", value: "name" },
        { text: "ZONES", value: "zones" },
        { text: "Phone", value: "phone" },
        { text: "Technician Type", value: "type" },
        { text: "UPDATED ON", value: "updated" },
        { text: "UPDATED BY", value: "updated_by" },
        { text: "ACTION", value: "action" },
      ];
      let list = [];
      for (let item of headers) {
        let { text, value } = item;
        let doc = {
          text,
          value,
          class: "text-capitalize",
          align: "start",
          sortable: true,
          divider: true,
        };
        if (value === "action") doc.divider = false;
        list.push(doc);
      }
      return list;
    },
    list() {
      return [...this.$store.getters.technicians].sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    },
  },
  methods: {
    formatPhone(phone) {
      return formatPhone(phone);
    },
    openChat(item) {
      let { name, phone } = item;
      if (this.isMobile) {
        this.$router.push({
          path: `/technician-sms-view/${phone}`,
          query: {
            id: phone,
            name: name,
            phone,
          },
        });
      } else {
        this.$router.push({
          path: `/technician-sms`,
          query: {
            id: phone,
            name: name,
            phone,
          },
        });
      }
    },
    updated({ updated_by }) {
      let name = updated_by;
      this.list.forEach((item) => {
        let { email, first_name, last_name } = item;
        if (email === updated_by) name = `${first_name} ${last_name}`;
      });
      return name;
    },
    type({ type }) {
      let name = "";
      this.types.forEach((item) => {
        if (item.value === type) name = item.name;
      });
      return name;
    },
  },
};
</script>

<style lang="scss"></style>
